export default __webpack_public_path__ + "static/media/Delphi methodology.05ab7784.pdf";